import { buildFaqSchema, serializeJsonLd } from '~/lib/structuredData';
import { getAnswerText } from '../search';

export default function FaqSchema({ items }) {
  const schema = buildFaqSchema(items.map(({ question, answer }) => ({ question, answer: getAnswerText(answer) })));
  return schema ? <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: serializeJsonLd(schema) }}/> : null;
}
